import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustedBy from './components/TrustedBy';
import WhyReachOut from './components/WhyReachOut';
import ValueProp from './components/ValueProp';
import Process from './components/Process';
import About from './components/About';
import ShouldYouDecide from './components/ShouldYouDecide';
import WhatYouLeaveWith from './components/WhatYouLeaveWith';
import ArticlesBand from './components/ArticlesBand';
import ScarcitySection from './components/ScarcitySection';
import PricingCTA from './components/PricingCTA';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function MainPage() {
  return (
    <div className="min-h-screen bg-brand-light relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-[600px] bg-brand-gold/4 blur-[150px] -z-10 rounded-full pointer-events-none" />
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <WhyReachOut />
        <ValueProp />
        <Process />
        <About />
        <ShouldYouDecide />
        <WhatYouLeaveWith />
        <ArticlesBand />
        <ScarcitySection />
        <PricingCTA />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </HashRouter>
  );
}